/** Maximum value for app rating */
export const TOTAL_STARS = 4;
export const STAR_RATINGS_TESTID = 'star-ratings';
export const NUMERIC_RATING_TESTID = 'numeric-rating';
export const YELLOW_STAR = 'yellowStar';
export const GREY_STAR = 'greyStar';
export const DISABLED_STAR = 'disabledStar';
export const QUARTER_STAR = 'quarterStar';
export const QUARTER_STAR_GRADIENT_ID = 'amktCommonQuarterStar';
export const QUARTER_STAR_GRADIENT_HOVER_ID = 'amktCommonQuarterStarHover';
export const HALF_STAR = 'halfStar';
export const HALF_STAR_GRADIENT_ID = 'amktCommonHalfStar';
export const HALF_STAR_GRADIENT_HOVER_ID = 'amktCommonHalfStarHover';
export const THREE_QUARTER_STAR = 'threeQuarterStar';
export const THREE_QUARTER_STAR_GRADIENT_ID = 'amktCommonThreeQuarterStar';
export const THREE_QUARTER_STAR_GRADIENT_HOVER_ID = 'amktCommonThreeQuarterStarHover';

// This configuration is for the "Ratings" component
export const STAR_FILL_MAP = {
  [YELLOW_STAR]: {
    fill: "var(--ds-icon-accent-orange, #E56910)",
    fillHover: "var(--ds-background-accent-orange-bolder, #C25100)"
  },
  [GREY_STAR]: {
    fill: "var(--ds-background-accent-gray-bolder, #626F86)",
    fillHover: "var(--ds-background-accent-gray-bolder-hovered, #44546F)"
  },
  [QUARTER_STAR]: {
    fill: "url(#".concat(QUARTER_STAR_GRADIENT_ID, ")"),
    fillHover: "url(#".concat(QUARTER_STAR_GRADIENT_HOVER_ID, ")")
  },
  [HALF_STAR]: {
    fill: "url(#".concat(HALF_STAR_GRADIENT_ID, ")"),
    fillHover: "url(#".concat(HALF_STAR_GRADIENT_HOVER_ID, ")")
  },
  [THREE_QUARTER_STAR]: {
    fill: "url(#".concat(THREE_QUARTER_STAR_GRADIENT_ID, ")"),
    fillHover: "url(#".concat(THREE_QUARTER_STAR_GRADIENT_HOVER_ID, ")")
  },
  [DISABLED_STAR]: {
    fill: "var(--ds-icon-disabled, #091E424F)"
  }
};